import ChatRoutes from './Chat/routes'
import CommunicationRulesRoutes from './CommunicationRules/routes'
import WhatsappPhonesRoutes from './WhatsappPhones/routes'
import AgentBotRoutes from './AgentBot/routes'

const CommunicationIndex = () => import('./Index.vue')

export default [
  {
    name: 'communication',
    path: 'communication',
    component: CommunicationIndex,
    children: [...ChatRoutes, ...CommunicationRulesRoutes, ...WhatsappPhonesRoutes, ...AgentBotRoutes]
  }
]
